import { render, staticRenderFns } from "./wall-member.vue?vue&type=template&id=4ed8d162&scoped=true"
import script from "./wall-member.vue?vue&type=script&lang=js"
export * from "./wall-member.vue?vue&type=script&lang=js"
import style0 from "./wall-member.vue?vue&type=style&index=0&id=4ed8d162&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed8d162",
  null
  
)

export default component.exports